import type {Destructible} from '../../../../utils/store';
import type {ModalController} from './Modal.controller';

import {MODAL_OFFSET} from '../../constants';

export class ModalResizeManager implements Destructible {
  private header = new ResizeObserver(() => this.resizeCallback());
  private parent = new ResizeObserver(() => this.resizeCallback());

  constructor(private readonly controller: ModalController) {}

  destruct() {
    this.parent.disconnect();
    this.header.disconnect();
  }

  observe() {
    const parentEl = this.controller.nodes.getParent();
    const headerEl = this.controller.nodes.getHeader();

    if (parentEl) {
      this.parent.observe(parentEl);
    }

    if (headerEl) {
      this.header.observe(headerEl);
    }

    this.resizeCallback();
  }

  private resizeCallback() {
    /**
     * dirty hack to fit scrollbars
     */
    const overlayRect = this.controller.nodes
      .getOverlay()
      ?.getBoundingClientRect();

    const headerEl = this.controller.nodes.getHeader();

    const footerEl = this.controller.nodes.getFooter();

    const scrollContainerEl = this.controller.nodes.getScrollContainer();

    const headerHeight = headerEl ? headerEl.clientHeight : 0;
    const footerHeight = footerEl ? footerEl.clientHeight : 0;

    if (scrollContainerEl) {
      const maxHeight =
        (overlayRect?.height || 0) -
        headerHeight -
        footerHeight -
        MODAL_OFFSET * 2;

      scrollContainerEl.style.maxHeight = `${maxHeight}px`;
    }
  }
}
